import LocalStorageService from '../../../../services/local-storage-service';
import { SET_PORTFOLIO_IDS_FILTER, SET_PORTFOLIO_GROUP_IDS_FILTER } from '../../../../constants/system/actions';

const setPortfolioIdsFilter: Function = (payload?: number[]): ReduxAction => {
  LocalStorageService.setPortfolioFilterIds(payload);

  return {
    type: SET_PORTFOLIO_IDS_FILTER, payload,
  };
};

const setPortfolioGroupIdsFilter: Function = (payload?: number[]): ReduxAction => {
  LocalStorageService.setPortfolioGroupFilterIds(payload);

  return {
    type: SET_PORTFOLIO_GROUP_IDS_FILTER, payload,
  };
};

export {
  setPortfolioIdsFilter,
  setPortfolioGroupIdsFilter,
};
